<template>
  <div v-if="this.$props.showModal">
    <div id="myModal" :class="[$style.modal]" @blur="hideModal()">
      <div :class="[$style.modalContent]">
        <div :class="[$style.divClose]">
          <span :class="[$style.close]" @click="hideModal()">&times;</span>
        </div>
        <div :class="[$style.headerModal]">
          <PdsIcon
          name="info"
          fill="#0061a0"
          :width="60"
          :height="60"
          isPointer />
          <div :class="$style.text">
          ¡Ups!</div>
        </div>
        <div :class="[$style.modalBody]">
          <span>
            Según nuestra información,
            ya tienes creada una cuenta para ingresar.
            Si no recuerdas tu clave puedes recuperarla
          </span>
        </div>
        <div :class="$style.footerModal">
          <div :class="$style.buttonContinue">
            <PdsButton
            :class="$style.buttonContinue"
            label="Ir al acceso de beneficiarios"
            role="tertiary"
            @click="pushBack()"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PdsButton from '@vue-pds/button';
import PdsIcon from '@vue-pds/icon';

export default {
  name: 'ModalCreated',
  components: {
    PdsButton,
    PdsIcon,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  methods: {
    hideModal() {
      this.$emit('disable', false);
    },
    pushBack() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped module>

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding-top: 100px;
  overflow: auto;
  letter-spacing: normal;
  background-color: rgba(0, 0, 0, 0.4);
}

.colorText {
  margin-top: 30px;
  font-size: 24px;
  font-style: normal;
  color: #c00000;
  text-align: center;
}

.text {
  margin-top: 30px;
  font-size: 24px;
  font-style: normal;
  text-align: center;
}

.modalContent {
  box-sizing: border-box;
  max-width: 374px;
  padding: 20px 0;
  margin: auto;
  color: #000000;
  background-color: #fefefe;
  border: 1px solid #c5c6c5;
  border-radius: 8px;
}

.divClose {
  padding: 0 30px;
  text-align: right;

  .close {
    font-size: 28px;
    color: #035fa4;
  }

  .close:hover,
  .close:focus {
    color: #035fa4;
    text-decoration: none;
    cursor: pointer;
  }
}

.headerModal {
  padding: 0 30px;
  padding-bottom: 25px;
  color: #333333;
  text-align: center;
}

.modalBody {
  max-height: 510px;
  padding: 20px 30px 30px;
  text-align: center;
}

.overAuto {
  overflow: auto;
}

.overHidden {
  overflow: hidden;
}

.shadowHeader {
  box-shadow: rgba(0, 0, 0, 0.35) 0 11px 10px;
}

.shadowFooter {
  box-shadow: rgba(0, 0, 0, 0.35) 0 -11px 10px;
}

.footerModal {
  z-index: 2;
  padding-top: 24px;
  margin-top: 5px;
  background-color: #ffffff;

  .divLink {
    margin: 0 auto;

    .link {
      display: flex;
      width: 220px;
      margin: 0 auto 35px;
      text-align: center;

      .icon {
        padding-right: 7px;
      }
    }
  }

  .buttonContinue {
    height: 42px;
    padding: 0 30px;
    text-align: center;

    button {
      display: block;
      width: 100%;
    }
  }
}

</style>
